import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll({ children }) {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            smoothWheel: true,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            wheelMultiplier: 1,
            touchMultiplier: 1.4,
        });

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        const id = requestAnimationFrame(raf);

        // Intercept in-page hash anchors so they use Lenis smooth-to-target
        const clickHandler = (e) => {
            const a = e.target.closest("a[href^='#'], [data-scroll-to]");
            if (!a) return;
            const targetSel =
                a.getAttribute("data-scroll-to") ||
                a.getAttribute("href");
            if (!targetSel || targetSel === "#") return;
            const el = document.querySelector(targetSel);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -60, duration: 1.2 });
            }
        };
        document.addEventListener("click", clickHandler);

        // Expose scrollTo for programmatic navigation
        window.__lenisScrollTo = (sel, opts = {}) => {
            const el = document.querySelector(sel);
            if (el) lenis.scrollTo(el, { offset: -60, duration: 1.2, ...opts });
        };

        return () => {
            cancelAnimationFrame(id);
            document.removeEventListener("click", clickHandler);
            lenis.destroy();
            delete window.__lenisScrollTo;
        };
    }, []);

    return children;
}
